<template>
  <v-dialog
    :value="show"
    fullscreen
    hide-overlay
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ $t(`title.${titleTrad}`) }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            icon
            @click="close"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <div class="subheading text-center pt-2">
        {{ $t(`title.${subtitleTrad}`) }}
      </div>

      <v-divider class="pa-1" />

      <v-date-picker
        id="date-picker-dialog"
        v-model="date"
        scrollable
        full-width
        :min="minDate"
        :locale="locale"
      />

      <bottom-action
        btn-del
        btn-cancel
        btn-valid
        :use-listener="useListener"
        @del="$emit('del')"
        @cancel="$emit('cancel')"
        @valid="valid"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'

export default {
  name: 'DateDialog',

  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    titleTrad: { type: String, default: 'validity_date' },
    subtitleTrad: { type: String, default: 'validity_date_selection' },
    show: { type: Boolean, default: false },
    btnClass: { type: String, default: null },
    btnColor: { type: String, default: null },
    autoClose: { type: Boolean, default: false },
    useListener: { type: Boolean, default: true },
    defaultDate: { type: String, default: null },
    minDate: { type: String, default: (new Date()).toISOString().substr(0, 10) },
  },

  data () {
    return {
      date: null,
      locale: MetierLocalStorage.getLocale()
    }
  },

  watch: {
    defaultDate (newDate) {
      this.date = newDate
    }
  },

  methods: {
    close () {
      if (this.autoClose) this.$emit('change', false)
      this.$emit('del')
    },
    valid () {
      if (this.autoClose) this.$emit('change', false)
      this.$emit('valid', this.date)
    }
  }
}
</script>
